import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { Button, ProgressBar } from 'react-bootstrap'
import { changeMyPassword } from '@severed-links/common.redherrings-reducers/account'
import { createNotification } from '@severed-links/common.redherrings-reducers/notifications'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import TextInput from '@severed-links/common.text-input'
import * as s from './ChangePassword.scss'
import { PASSWORD_VALIDATOR, PASSWORD_SCORE, MINIMUM_PASSWORD_SCORE } from '@severed-links/common.redherrings-constants'
import PasswordValidationRules from '../ForgotPassword/PasswordValidationRules'
import zxcvbn from 'zxcvbn'

const ChangeMyPassword = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [password, setPassword] = useState('')
    const [progressBar, setProgressBar] = useState({ length: 0, style: 'danger' })
    const [failedRules, setFailedRules] = useState([])

    useEffect(() => { validatePassword() }, [password])

    const validatePassword = () => {
        setFailedRules(password ? PASSWORD_VALIDATOR.validate(password, { list: true }) : [])
        const _passwordStrength = zxcvbn(password)
        const _passwordLength = PASSWORD_SCORE(password.length, _passwordStrength.score)
        var style = 'danger'
        if (_passwordLength >= MINIMUM_PASSWORD_SCORE) style = 'success'
        else if (_passwordLength >= MINIMUM_PASSWORD_SCORE / 2.0) style = 'warning'
        setProgressBar({ length: _passwordLength, style })
    }

    const canSubmit = !!password && !failedRules.length && progressBar.length >= MINIMUM_PASSWORD_SCORE

    const strengthLabel = () => {
        if (!password) return 'Enter a password'
        if (progressBar.length >= MINIMUM_PASSWORD_SCORE) return 'Strong enough'
        if (progressBar.length >= MINIMUM_PASSWORD_SCORE / 2.0) return 'Getting closer'
        return 'Needs work'
    }
    
    const doChangeMyPassword = () => {
        if (!canSubmit) return
        dispatch(changeMyPassword(password))
        .then(action => {
            if (action.payload.messageType === 'success') {
                setPassword('')
                setFailedRules([])
            }
            dispatch(createNotification({ message: action.payload.message, type: action.payload.messageType, headline: action.payload.subject, timeout: 4000 }))
        })
    }

    return (
        <div className={s.container}>
            <section className={s.hero}>
                <div className={s.heroIcon}><FontAwesomeIcon name='lock' /></div>
                <div>
                    <div className={s.eyebrow}>Account Security</div>
                    <h2>Change password</h2>
                    <p>Use at least 8 characters, including a number and a strong mix of characters.</p>
                </div>
            </section>

            <form className={s.passwordPanel} onSubmit={e => {
                e.preventDefault()
                doChangeMyPassword()
            }}>
                <TextInput type='password'
                    name='password'
                    value={password}
                    autoFocus
                    autoCapitalize='none'
                    label='New password'
                    required
                    showValidState={!!password}
                    isValid={canSubmit}
                    onChange={_text => setPassword(_text)} />

                <div className={s.strengthRow}>
                    <ProgressBar now={progressBar.length}
                        variant={progressBar.style}
                        className={s.progressBar} />
                    <span className={`${s.strengthLabel} ${s[progressBar.style]}`}>{strengthLabel()}</span>
                </div>

                <div className={s.actions}>
                    <Button type='button' size='lg' variant='light' onClick={() => navigate(-1)}>
                        <FontAwesomeIcon name='times' />
                        <span>cancel</span>
                    </Button>
                    <Button disabled={!canSubmit}
                        type='submit' size='lg' variant='primary'>
                        <FontAwesomeIcon name='lock' />
                        <span>change password</span>
                    </Button>
                </div>

                <PasswordValidationRules show={!!password}
                    failedRules={failedRules}
                    score={progressBar.length} />
            </form>
        </div>
    )
}

export default ChangeMyPassword
